import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart',
  templateUrl: './chart.component.html'
})
export class ChartComponent {
  constructor() {}
}
